import { useState } from "react";
import Footer from "../../components/Footer/Footer";
import AddUserModal from "../../components/Modal/AddUserModal";
import PageHeader from "../../components/TopHeader/PageHeader";
import {
  AddBtn,
  AddImg,
  Container,
  ContentContainer,
  DeleteBtn,
  DeleteImg,
  ListTitle,
  Table,
  TableCell,
  TableContainer,
  TableHeader,
  TableHeaderRow,
  TableRow,
  TitleContainer,
  TitleLeftContainer,
  TitleRightContainer,
} from "./UserPageStyle";
import Seo from "../../components/Seo";
import requiredAuth from "../../components/requiredAuth";
import { useQuery } from "@tanstack/react-query";
import { accessTokenAtom } from "../../recoil/auth";
import { useRecoilValue } from "recoil";
import DeleteUserModal from "../../components/Modal/DeleteUserModal";
import { getSubusers } from "../../apis/api/Subuser/getSubuser";
import { useTranslation } from "react-i18next";
import { userInfoAtom } from "../../recoil";
import { useTimeFormat } from "../../library/useTimeFormat";

const tableTitle = ["authority", "email", "name", "phone", "creation date"];

function UserPage() {
  const accessToken = useRecoilValue(accessTokenAtom);
  const [addUserModalIsOpen, setAddUserModalIsOpen] = useState(false);
  const [deleteUserModalIsOpen, setDeleteUserModalIsOpen] = useState(false);
  const userInfo = useRecoilValue(userInfoAtom);
  const { data: userData } = useQuery({
    queryKey: ["users"],
    queryFn: () => getSubusers(accessToken),
  });

  function openAddUserModal() {
    setAddUserModalIsOpen(true);
  }

  function openDeleteUserModal() {
    setDeleteUserModalIsOpen(true);
  }

  const { t } = useTranslation();
  const { date } = useTimeFormat();

  return (
    <Container>
      <Seo title={t(`user`)} />
      <PageHeader title={t(`user`)} />
      <ContentContainer>
        <TitleContainer>
          <TitleLeftContainer>
            <ListTitle>{t(`user list`)}</ListTitle>
          </TitleLeftContainer>
          <TitleRightContainer style={{ display: "flex" }}>
            <AddBtn onClick={openAddUserModal}>
              <AddImg />
            </AddBtn>
            <DeleteBtn onClick={openDeleteUserModal} style={{ marginLeft: "10px" }}>
              <DeleteImg />
            </DeleteBtn>
          </TitleRightContainer>
        </TitleContainer>
        <TableContainer>
          <Table>
            <thead>
              <TableHeaderRow>
                {tableTitle.map((item, idx) => {
                  return <TableHeader key={idx}>{t(item)}</TableHeader>;
                })}
              </TableHeaderRow>
            </thead>
            <tbody>
              {userData?.map((user) => {
                if (user?.email !== userInfo?.email) {
                  return (
                    <TableRow key={user.email}>
                      <TableCell>{user.role}</TableCell>
                      <TableCell>{user.email}</TableCell>
                      <TableCell>{user.nickname}</TableCell>
                      <TableCell>{user.phone || " - "}</TableCell>
                      <TableCell>{date(user.createdAt)}</TableCell>
                    </TableRow>
                  );
                } else {
                  return null;
                }
              })}
            </tbody>
          </Table>
        </TableContainer>
      </ContentContainer>
      <Footer />
      <AddUserModal
        isOpen={addUserModalIsOpen}
        isClose={setAddUserModalIsOpen}
      />
      <DeleteUserModal
        isOpen={deleteUserModalIsOpen}
        isClose={setDeleteUserModalIsOpen}
      />
    </Container>
  );
}

export default requiredAuth(UserPage);
